
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CoordinatorSidebar from "../CoordinatorSidebar/CoordinatorSidebar";
import CoordinatorNavbar from "../CoordinatorNavbar/CoordinatorNavbar";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { useEffect, useState } from "react";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import { CirclesWithBar } from "react-loader-spinner";
const WithdrawlRequest = () => {
    const [withdraw, setWithDraw] = useState([])
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(7);
    const [loading, setLoading] = useState(true);

    const getwithdrawReq = async () => {
        setLoading(true); // Set loading true before API call
        try {
            const response = await CoordinatorApiServices.getwithdrawReq(
                offset,
                limit,
            );
            setWithDraw(response.data);

            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        }
        finally {
            setLoading(false); // Set loading false after API call
        }
    };

    useEffect(() => {
        getwithdrawReq();
    }, [offset]);
    const removeTimeFromDate = (dateString) => {
        if (!dateString) return '';
        const dateObject = new Date(dateString);
        // Ensure the date is parsed as UTC
        const utcYear = dateObject.getUTCFullYear();
        const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
        const utcDay = dateObject.getUTCDate();
        return `${utcDay} ${utcMonth} , ${utcYear}`;

    };
    return (
        <div className="d-flex">
            <CoordinatorSidebar />
            <div className="mainLayout-content">
                <CoordinatorNavbar />
                <div className="main_content_two contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">Withdraw Request</h1>
                    </div>
                    <div className="table_container" style={{ display: "block" }}>

                        <div className="table_title">
                            <div className="table_headings mt-2 Commonclass">
                                <h1 className="black fs-18 fw-600 mb-0">
                                </h1>
                            </div>
                            {loading ? (
                                <div className="text-center d-flex justify-content-center">
                                    <CirclesWithBar
                                        height="80"
                                        width="80"
                                        color="#F6821F"
                                        ariaLabel="bars-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                </div>
                            ) : (
                                <>
                                    {withdraw.length === 0 ? (
                                        <div className="no-records-container-coordinator text-center" >
                                            <div className="no-record-image " >
                                                <Image src={PngImages.no_record} className="img-fluid" />
                                            </div>
                                            <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
                                            {/* <div className="d-flex justify-content-center">
                                        <SubmitButtonTwo title={"Go to Packages"} className=" Package-button mb-4" onclick={handleButtonClick}></SubmitButtonTwo>
                                    </div> */}

                                        </div>
                                    ) : (
                                        <div className="Tableorderhistory tablebordernone" style={{ overflowX: "auto" }}>
                                            <table
                                                className="table tablecoordinator mb-0 pt-3"
                                                id="dtHorizontalExample"
                                                cellSpacing="0"
                                                width="100%"
                                            >
                                                <thead style={{ backgroundColor: '#F5F5F5' }}>
                                                    <tr >
                                                        <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "1%" }}>
                                                            Sr No.
                                                        </th>
                                                        <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                            Date
                                                        </th>
                                                        <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                                            Request Amount
                                                        </th>
                                                        <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                                            Recieved Amount
                                                        </th>
                                                        <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg_light">
                                                    {withdraw.map((item, index) => (
                                                        <tr key={index} className="table_heading">
                                                            <td className="small-medium-text fw-600 " style={{ paddingLeft: '40px' }}>{limit * offset + (index + 1)}</td>
                                                            <td className="small-medium-text fw-600">{removeTimeFromDate(item.create_date)}</td>
                                                            <td className="small-medium-text fw-600">{item.amount}</td>
                                                            <td className="small-medium-text fw-600">{item.paidAmount}</td>
                                                            <td className="small-medium-text fw-600 text-capitalize">{item.status == "approved" ? <div className="darkgreen">{item.status}</div> : <div className="darkorange">{item.status}</div>}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                        </div>

                                    )}
                                </>)}

                        </div>
                    </div>
                    <div className="row mt-3 align-items-center parentcustomnavbtn">
                        <div className="col-md-6 col-sm-6 ">     <p className=" small-text fw-500 mb-0" style={{ opacity: '0.5', fontStyle: "italic" }}>
                            {availableDataCount > 0
                                ? `Showing ${Math.min(offset * limit + 1, availableDataCount)} to ${Math.min((offset + 1) * limit, availableDataCount)} of ${availableDataCount} entries`
                                : "Showing No Entries"}</p>
                        </div>
                        <div className="col-md-6 col-sm-6 pagebtnrespo ">  {
                            generatePaginationFooter(
                                availableDataCount,
                                limit,
                                offset,
                                setOffset
                            )}</div>

                    </div>
                </div>
            </div>
        </div>

    )
};

export default WithdrawlRequest;
